module.exports = __webpack_public_path__ + "static/media/gds_gray.eed9c5e7.svg";